<template>
  <div>
    <v-data-table :headers="computedHeaders" :items="item_products" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>List Layanan</v-toolbar-title>
          <v-dialog v-model="dialog" max-width="80%">
            <v-data-table :headers="jadwalHeaders" :items="jadwal_items">
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>List Jadwal {{selectedLayanan}}</v-toolbar-title>
                </v-toolbar>
              </template>
              <template v-slot:[`item.start`]="{ item }"  >
                {{formatdate(item.start)}}
              </template>
              <template v-slot:[`item.finish`]="{ item }"  >
                {{formatdate(item.finish)}}
              </template>
              <template v-slot:[`item.no`]="{ item }">
                {{(jadwal_items.indexOf(item)+1) + '.'}}
              </template>
            </v-data-table>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.no`]="{ item }">
        {{(item_products.indexOf(item)+1) + '.'}}
      </template>
      <template v-slot:[`item.harga_jual`]="{ item }">
        {{convertCurrency(item.harga_jual)}}
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon small class="mr-2" v-on="on" @click="modalDetail(item)">info</v-icon>
          </template>
          <span>Detail</span>
        </v-tooltip>
        <!-- <v-tooltip top v-if="item.alreadyread">
          <template v-slot:activator="{ on }">
            <v-icon small class="mr-2" v-on="on" >mdi-email</v-icon>
          </template>
          <span>Read</span>
        </v-tooltip>
        <v-tooltip top v-else>
          <template v-slot:activator="{ on }">
            <v-icon small class="mr-2" v-on="on" color = "green">mdi-email</v-icon>
          </template>
          <span>UnRead</span>
        </v-tooltip> -->
      </template>
      <template v-slot:no-data>
        <span class="text-center">No data available.</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import forEach from "lodash/forEach";
import slice from "lodash/slice";
import find from "lodash/find";
import isEmpty from "lodash/isEmpty";
import itemTemplate from '@/components/ItemTemplate.vue';
import { formatCurrency } from "@/libs/number";
import moment from "moment";
export default {
  data: () => ({
    itemTemplate,
    dialog: false,
    expand: false,
    headers: [
      {
        text: "No.",
        align: "left",
        value: "no"
      },
      {
        text: "Nama",
        align: "left",
        value: "name"
      },
      { text: "Description", value: "description" },
      { text: "Harga Jual", value: "harga_jual" },
      { text: "Actions", value: "action", sortable: false }
    ],
    jadwalHeaders: [
      {
        text: "No.",
        align: "left",
        value: "no"
      },
      {
        text: "Nama Order",
        align: "left",
        value: "submissions[0].name"
      },
      {
        text: "Durasi",
        align: "left",
        value: "item.qty"
      },
      { text: "Mulai", value: "start" },
      { text: "Selesai", value: "finish" }
    ],
    item_products: [],
    jadwal_items: [],
    selectedLayanan: ''
  }),

  computed: {
    ...mapGetters({
    }),
    
    computedHeaders () {
      let editedHeaders = this.headers
      // if(!this.statusCanEditByRole.includes(this.role)){
      //   editedHeaders = this.headers.filter(header => header.value !== "status")  
      // }
      return editedHeaders;
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    formatdate(value){
      return moment(value).format("DD-MM-YYYY HH:mm")
    },
    ...mapActions({
      getUserById: "user/getUserById",
      searchItem: "item/searchItem",
      getScheduleByProductId: "products/getScheduleByProductId",
      dataProducts: "products/getProductJasa",
      deleteRead: "pemasukan/deleteRead",
      createRead: "pemasukan/createRead"
    }),
    convertCurrency(total){
      return "Rp. "+formatCurrency(total);
    },
    async initialize() {
      const userLogin = JSON.parse(window.localStorage.getItem('user_data'))
      this.role = userLogin.roles[0].name;
      const dataLayanan = await this.dataProducts()
      forEach(dataLayanan.data.attributes, data => {
        data.harga_jual = Number(data.harga_jual)
        this.item_products.push(data)
      })
    }, 

    async modalDetail(item){
      this.jadwal_items = []
      // console.log('item', item)
      this.selectedLayanan = item.name
      const response = await this.getScheduleByProductId(item.id)
      // const dataRead = {
      //   type : 'schedule',
      //   type_id : item.id
      // }
      // await this.createRead(dataRead)
      forEach(response.data.attributes, data => {
        data.item.qty = Number(data.item.qty) + ' Jam'
        this.jadwal_items.push(data)
      })

      // console.log('response', response)
      this.dialog = true
    },

    close() {
      this.dialog = false
    },
  }
};
</script>